import { Injectable } from '@angular/core';

import { fromEvent, shareReplay } from 'rxjs';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';

export type DeviceType = 'mobile' | 'desktop';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  desktopBreakpoint = 992;

  type$ = this.getWindowWidthObservable().pipe(
    startWith(window.innerWidth),
    map(windowWidth => this.getDeviceByWidth(windowWidth)),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  constructor() {}

  getWindowWidthObservable() {
    return fromEvent(window, 'resize').pipe(map(event => (event.target as Window)?.innerWidth));
  }

  getDeviceByWidth(width: number): DeviceType {
    if (width >= this.desktopBreakpoint) {
      return 'desktop';
    }
    return 'mobile';
  }
}
